const lettersColors = {
  A: "var(--primary-500)",
  B: "var(--primary-400)",
  C: "var(--primary-300)",
  D: "var(--secondary-500)",
  E: "var(--secondary-400)",
  F: "var(--secondary-300)",
  G: "var(--info-400)",
  H: "var(--info-500)",
  I: "var(--info-600)",
  J: "var(--accent-1-400)",
  K: "var(--neutral-500)",
  L: "var(--neutral-600)",
  M: "var(--accent-2-400)",
  N: "var(--accent-2-500)",
  O: "var(--accent-2-600)",
  P: "var(--accent-3-400)",
  Q: "var(--accent-3-500)",
  R: "var(--accent-3-600)",
  S: "var(--accent-4-400)",
  T: "var(--accent-4-500)",
  U: "var(--accent-4-600)",
  V: "var(--accent-5-400)",
  W: "var(--accent-5-500)",
  X: "var(--accent-5-600)",
  Y: "var(--accent-1-500)",
  Z: "var(--accent-1-600)",
};

export default function getLetterColor({ letter }) {
  if (typeof letter !== "string" || letter.length !== 1) {
    throw new TypeError("Invalid input: Expected a single letter.");
  }
  return lettersColors[letter.toUpperCase()] || "var(--neutral-500)";
}
